// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Copyright-module--wrapper--3gZPN"};